import { Button, Modal, Steps } from "antd";
import { separateThenGroup, StatusCode, UserRoles } from "common/enums";
import Breadcrumbs from "components/breadcrumbs";
import * as appRoutes from "config/routes.config";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CloseIcon from "../../../assets/images/app/close-Icon.svg";
import TeacherOnboarding1 from "../../../assets/images/app/onboarding/teacher/1.png";
import TeacherOnboarding2 from "../../../assets/images/app/onboarding/teacher/2.png";
import TeacherOnboarding3 from "../../../assets/images/app/onboarding/teacher/3.png";
import TeacherOnboarding4 from "../../../assets/images/app/onboarding/teacher/4.png";
import TeacherOnboarding5 from "../../../assets/images/app/onboarding/teacher/5.png";
import TeacherOnboarding6 from "../../../assets/images/app/onboarding/teacher/6.png";
import TeacherOnboarding7 from "../../../assets/images/app/onboarding/teacher/7.png";
import TeacherOnboarding8 from "../../../assets/images/app/onboarding/teacher/8.png";

import StudentOnboarding1 from "../../../assets/images/app/onboarding/student/1.png";
import StudentOnboarding2 from "../../../assets/images/app/onboarding/student/2.png";
import StudentOnboarding3 from "../../../assets/images/app/onboarding/student/3.png";
import StudentOnboarding4 from "../../../assets/images/app/onboarding/student/4.png";
import StudentOnboarding5 from "../../../assets/images/app/onboarding/student/5.png";
import StudentOnboarding6 from "../../../assets/images/app/onboarding/student/6.png";
import StudentOnboarding7 from "../../../assets/images/app/onboarding/student/7.png";
import StudentOnboarding8 from "../../../assets/images/app/onboarding/student/8.png";

import * as AUTH_SERVICES from "api/services/auth/auth.services";
import Gamification from "components/gamification";
import { updateUser } from "store/auth/authSlice";
import MainContent from "./components/mainContent";
import TeacherInfos from "./components/profileInfo";
import TeacherEvents from "./components/teacherEvents";
import s from "./style.module.css";

import * as USERS_SERVICES from "api/services/auth/auth.services";

interface Props { }

const { Step } = Steps;

const TeacherActivities = (props: Props) => {

  const auth = useSelector((state) => state.auth);
  const { isAppInMaintenance } = useSelector((state) => state.auth);
  const [postsCount, setPostsCount] = useState(auth?.user?.postsNum ? auth?.user?.postsNum : 0);
  const [docsCount, setDocsCount] = useState(auth?.user?.docsNum ? auth?.user?.docsNum : 0);

  const [gamificationData, setGamificationData] = useState<any>();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAddPost = () => {
    setPostsCount(postsCount + 1);
  };

  const handleAddDocs = (numToAdd: any) => {
    setDocsCount(docsCount + numToAdd);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleClose = () => {
    setIsModalVisible(false);
  };
  const [current, setCurrent] = useState<number>(1);

  const updateProfile = async () => {
    const finalData = {
      firstLogin: false,
    };
    try {
      const response = await AUTH_SERVICES.updateTeacher(auth?.user?._id, {
        ...finalData,
      });
      if (response?.statusCode === StatusCode.OK) {
        dispatch(
          updateUser({ ...auth?.user, firstLogin: false })
        );
      }
    } catch (error: any) {
      let content = "";
      for (
        let index = 0;
        index < error?.response?.data?.message?.length;
        index++
      ) {
        content = error?.response?.data?.message[index] + ", " + content;
      }
    }
  }

  const getGamification = async () => {
    try {
      const response = await USERS_SERVICES.getGamification(auth?.user?.roles[0].includes("teacher") ? "teacher" : "student");
      if (response?.statusCode === StatusCode.OK) {
        const separated = separateThenGroup(response?.data);
        setGamificationData(separated);
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (auth?.user) {
      getGamification();
    }
  }, [auth]);

  useEffect(() => {
    setIsModalVisible(true);
  }, []);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const isTeacher = auth.user?.roles?.includes(UserRoles.TEACHER);
    const isOTP = auth.user?.step === "otp";
    if (isLoggedIn && isTeacher && isOTP) {
      navigate(appRoutes.REGISTER_TEACHER_BY_EMAIL);
    }
  }, [auth.isLoggedIn, navigate, auth.user?.roles]);

  useEffect(() => {
    if (auth.user) {
      updateProfile();
    }
  }, [auth.user]);

  useEffect(() => {
    if (isAppInMaintenance) {
      navigate(appRoutes.MAINTENANCE);
    };
  }, [isAppInMaintenance]);

  return (
    <React.Fragment>
      {isMobile && auth?.user?.accountManaged !== "" && <div style={{ height: "0px", width: "100%" }}></div>}
      <Breadcrumbs isAds={true} />
      <div className={s.containerBox}>
        <div className={s.mainBox}>
          <div className={s.flex}>
            <div className={s.left}>
              <TeacherInfos postsCount={postsCount} docsCount={docsCount} />
            </div>
            <div className={s.main}>
              <MainContent onAddPost={handleAddPost} handleAddDocs={handleAddDocs} />
            </div>
            <div className={s.right}>
              <TeacherEvents />
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="onboadingMModal"
        centered
        visible={isModalVisible}
        closable={false}
        footer={null}
        onCancel={handleClose}
        maskClosable={false}
        keyboard={false}
      >
        <div className={s.modalContentBox}>
          <div style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", marginBottom: "20px", marginLeft: current === 8 ? "0px" : "0px" }}>
            <Button
              onClick={() => navigate(appRoutes.TEACHER_ACTIVITIES)}
              className={s.closeButton}
            >
              <img
                src={CloseIcon}
                alt=""
                style={{ height: isMobile ? "15px" : "20px", marginRight: "5px" }}
              />
              Passer
            </Button>
          </div>

          <div style={{ width: isMobile ? "100%" : "70%", margin: "0px auto", textAlign: "center" }}>
            <div className={s.step} style={{ width: current === 8 ? "100%" : "100%" }}>
              <Steps
                current={current - 1}
                labelPlacement="vertical"
                responsive={true}
                style={{ position: "relative", left: isMobile ? "0px" : "-55px", top: "3px" }}
              >
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((stepNumber) => (
                  <Step
                    key={stepNumber}
                    icon={<div style={{ background: current === stepNumber ? "#7FB1B2" : "#FFF", border: "1px solid #7FB1B2", color: current === stepNumber ? "#FFF" : "#7FB1B2", height: isMobile ? "30px" : "40px", width: isMobile ? "30px" : "40px", borderRadius: "50%", textAlign: "center", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>{stepNumber}</div>}
                    style={{ cursor: "pointer", width: "7px" }}
                    onClick={() => setCurrent(stepNumber)}
                  />
                ))}
              </Steps>
            </div>
          </div>
          {auth?.user?.roles[0].includes("teacher") && <div style={{ height: "auto", width: isMobile ? "100%" : "932px", margin: "20px auto", display: "flex", alignItems: "center", justifyContent: "center", objectFit: "contain" }}>
            {current === 1 && <img src={TeacherOnboarding1} style={{ height: "auto", width: "100%" }}></img>}
            {current === 2 && <img src={TeacherOnboarding2} style={{ height: "auto", width: "100%" }}></img>}
            {current === 3 && <img src={TeacherOnboarding3} style={{ height: "auto", width: "100%" }}></img>}
            {current === 4 && <img src={TeacherOnboarding4} style={{ height: "auto", width: "100%" }}></img>}
            {current === 5 && <img src={TeacherOnboarding5} style={{ height: "auto", width: "100%" }}></img>}
            {current === 6 && <img src={TeacherOnboarding6} style={{ height: "auto", width: "100%" }}></img>}
            {current === 7 && <img src={TeacherOnboarding7} style={{ height: "auto", width: "100%" }}></img>}
            {current === 8 && <Gamification data={gamificationData} userType="teacher" displayedFromOnboarding={true} />}
            {current === 9 && <img src={TeacherOnboarding8} style={{ height: "auto", width: "100%" }}></img>}
          </div>}

          {auth?.user?.roles[0].includes("student") && <div style={{ height: "auto", width: isMobile ? "100%" : "932px", margin: "20px auto", display: "flex", alignItems: "center", justifyContent: "center", objectFit: "contain" }}>
            {current === 1 && <img src={StudentOnboarding1} style={{ height: "auto", width: "100%" }}></img>}
            {current === 2 && <img src={StudentOnboarding2} style={{ height: "auto", width: "100%" }}></img>}
            {current === 3 && <img src={StudentOnboarding3} style={{ height: "auto", width: "100%" }}></img>}
            {current === 4 && <img src={StudentOnboarding4} style={{ height: "auto", width: "100%" }}></img>}
            {current === 5 && <img src={StudentOnboarding5} style={{ height: "auto", width: "100%" }}></img>}
            {current === 6 && <img src={StudentOnboarding6} style={{ height: "auto", width: "100%" }}></img>}
            {current === 7 && <img src={StudentOnboarding7} style={{ height: "auto", width: "100%" }}></img>}
            {current === 8 && <Gamification data={gamificationData} userType="student" displayedFromOnboarding={true} />}
            {current === 9 && <img src={StudentOnboarding8} style={{ height: "auto", width: "100%" }}></img>}
          </div>}

          <div style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", margin: "20px auto" }}>
            <Button
              onClick={() => current <= 8 ? setCurrent(current + 1) : navigate(appRoutes.TEACHER_ACTIVITIES)}
              className={s.nextButton}
            >
              Suivant
            </Button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default TeacherActivities;
